import axios from 'axios';
import axiosRetry from 'axios-retry';
import { useContext, useRef } from "react";
import { ConfigContext } from '../security/ConfigContext';
import { useOktaAuth } from '@okta/okta-react';
import Agent from 'agentkeepalive';
const keepAliveAgent = new Agent({
  maxSockets: 100,
  maxFreeSockets: 10,
  timeout: 60000, // active socket keepalive for 60 seconds
  freeSocketTimeout: 30000, // free socket keepalive for 30 seconds
});

const axiosInstance = axios.create({
  headers: {
    'Content-Type': 'application/json'
  },
  httpAgent: keepAliveAgent
});

axiosInstance.interceptors.request.use(function (config:any) {
  config.baseURL = config.path.host;
  config.headers['Authorization'] = 'Bearer ' + config.accessToken;
  return config;
},function (error) {
   return Promise.reject(error);
});

axiosRetry(axiosInstance, {
  retries: 2,
  shouldResetTimeout: true
});  

const useAxios =  ()  => {
  const [config] = useContext(ConfigContext);
  const {authState, oktaAuth } = useOktaAuth();
  let previousController = useRef(null);

  function get (httpConfig){
    if(httpConfig.signal){
      httpConfig = setAbortController(httpConfig);
    }
    httpConfig.method = 'get';
    return request(httpConfig);
  }

  function post (httpConfig){
    if(httpConfig.signal){
      httpConfig = setAbortController(httpConfig);
    }
    httpConfig.method = 'post';
    return request(httpConfig);
  }

  function put (configPut){
    if(configPut.signal){
      configPut = setAbortController(configPut);
    }
    configPut.method = 'put';
    return request(configPut);
  }

  function deleteReq (httpConfig){
    if(httpConfig.signal){
      httpConfig = setAbortController(httpConfig);
    }
    httpConfig.method = 'delete';
    return request(httpConfig);
  }

  async function request (params) {
    let callParams = {...params, ...config};
    let isAuthenticated = authState?.isAuthenticated || false;
    if (isAuthenticated) {
        const objAccessToken = await oktaAuth.tokenManager.get("accessToken");
        const accessToken = objAccessToken?.accessToken;
        callParams.accessToken = accessToken;
        try {
          let res;
          res = await axiosInstance(callParams);
          return res.data;
            }
        catch (e) {
          console.log('Api call error', e);
          return Promise.reject(e);          
            }
        }
  }

  function setAbortController (httpConfig) {
    if(previousController.current){
      previousController.current.abort();
    }
    return {...httpConfig, signal: getSignal()};
  }
  
  function getSignal () {
    const controller = new AbortController();
    const signal = controller.signal;
    previousController.current = controller;
    return signal;
  }

  return {
      get,
      post,
      put,
      deleteReq
  }
};

export default useAxios;